export default "__VITE_ASSET__ed43e342__"